import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

export default function usePageViews() {
  const location = useLocation()
  useEffect(() => {
    // Add other page view tracking (like Google Analytics) as needed
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search })
  }, [location])
}
